import React from "react";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

export const colorPathogenicity = (pathogenicity) => {
  const color = getPathogenicityColorByAllNames(pathogenicity.toLowerCase());
  const fontWeight = color ? "bold" : "";
  return (
    <div style={{ color, fontWeight }} className="varsome-horiz-list-value">
      {pathogenicity}
    </div>
  );
};

export const formatDates = (date) => {
  const res = date.split("-");
  const formattedDate = `${res[2]}-${res[1]}-${res[0]}`;
  return formattedDate;
};
